export const Globe = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2"/>
  <path d="M17 29C18 27.5 21 23.3804 21 16.4483C21 9.51615 18.5 4.5 17 3" stroke="currentColor" stroke-width="2"/>
  <path d="M15 3C14 4.5 11 8.6196 11 15.5517C11 22.4839 13.5 27.5 15 29" stroke="currentColor" stroke-width="2"/>
  <path d="M3 16H29" stroke="currentColor" stroke-width="2"/>
</svg>`;
